// extracted by mini-css-extract-plugin
export default {"notification":"kL0ipyHsGcyv1lEc6lyP","notificationContent":"VRNeeYeeRF6RhFDckp3Q"};